import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { RxComposite } from '../model/rx-composite';

@Directive({
  selector: '[dragDrop]',
})
export class DragDropDirective extends RxComposite {
  @Output() files: EventEmitter<any[]> = new EventEmitter();
  @Output() error: EventEmitter<any> = new EventEmitter();

  @HostBinding('style.border') private border = '#c3c2c2 1px dashed';

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.border = '#0E62F9 1px dashed';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.border = '#c3c2c2 1px dashed';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.border = '#c3c2c2 1px dashed';

    const files: any[] = [];

    const file = evt.dataTransfer.files[0];

    console.log('type', file.type);

    if (file.type !== this.file.jpg && file.type !== this.file.png) {
      this.error.emit(true);
      return;
    } else {
      this.error.emit(false);
    }

    const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
    files.push({ file, url });

    if (files.length > 0) {
      this.files.emit(files);
    }
  }
}
